import { z } from 'zod';
import { AuctionStatus } from '@/types/auction/auction-status.type.ts';
import { Car, CarSchema } from '@/types/car.type.ts';
import { InProgressAuctionBroadcastItem } from '@/types/auction/auctions.type.ts';
import { DeliveryPrice, DeliveryPriceSchema } from '@/types/delivery-price.type.ts';
import { AuctionBid, AuctionBidSchema } from '@/types/auction/auction-bid.type.ts';

export type Auction = {
    id: number,
    start_date: string,
    end_date: string,
    status: AuctionStatus,
    start_price: number,
    car: Car,
    bids_count: number,
    user_bids?: {
        id: number,
        value: number,
        created_at: string,
    }[] | null,
    is_user_lot: boolean,
    broadcastInfo?: InProgressAuctionBroadcastItem,
    user_joining?: boolean,
    delivery_price?: DeliveryPrice | null,
    is_winner?: boolean,
    winner?: AuctionBid,
    delivery_required?: boolean,
};

export const AuctionSchema = z.object({
    id: z.number(),
    start_date: z.string(),
    end_date: z.string(),
    status: z.nativeEnum(AuctionStatus),
    start_price: z.number(),
    car: CarSchema,
    bids_count: z.number(),
    user_bids: z.array(z.object({
        id: z.number(),
        value: z.number(),
        created_at: z.string(),
    })).nullable().optional(),
    is_user_lot: z.boolean().default(false),
    user_joining: z.boolean().optional(),
    delivery_price: DeliveryPriceSchema.nullable().optional(),
    is_winner: z.boolean().optional(),
    winner: AuctionBidSchema.nullable().optional(),
    delivery_required: z.boolean().optional(),
});
